import { statusIconColorPairs } from '@sharedCR/common/StatusIcon/StatusIcon.constants';

import { COLOR_PALETTE } from 'constants/ui';

export const iconColorPairs = {
  primary: {
    backgroundColor: COLOR_PALETTE.BLUE[2],
    color: COLOR_PALETTE.BLUE[7],
  },
  secondary: {
    backgroundColor: COLOR_PALETTE.GREEN[2],
    color: COLOR_PALETTE.GREEN[8],
  },
  ...statusIconColorPairs,
};
